import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "fw-semibold" }, [
  /*#__PURE__*/_createTextVNode("Organe "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_6 = { class: "col-md-6 mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "fw-semibold" }, [
  /*#__PURE__*/_createTextVNode("Mandature "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-3" }, "Assignation des postes", -1)
const _hoisted_10 = { class: "row g-3" }
const _hoisted_11 = { class: "border rounded p-3 bg-light h-100 d-flex flex-column" }
const _hoisted_12 = { class: "fw-bold text-primary mb-2" }
const _hoisted_13 = { class: "mt-auto" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "mt-4 d-flex gap-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-success"
}, "Valider les assignations", -1)
const _hoisted_17 = {
  class: "modal fade",
  id: "createMembreModal",
  tabindex: "-1"
}
const _hoisted_18 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_19 = { class: "modal-content" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Nouveau membre"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal"
  })
], -1)
const _hoisted_21 = { class: "modal-body" }
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createTextVNode("Nom "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createTextVNode("Prénom "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Photo (facultatif)", -1)
const _hoisted_28 = { class: "modal-footer" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, "Annuler", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Form, {
          onSubmit: _ctx.submitAssign,
          "validation-schema": _ctx.assignationSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_Field, { name: "organes" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.organesOptions,
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      placeholder: "Sélectionner l'organe",
                      valueProp: "value",
                      label: "label",
                      onChange: _ctx.onOrganeChange,
                      searchable: true
                    }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "organes",
                  class: "text-danger fs-sm-14"
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_Field, { name: "mandatures" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.mandaturesOptions,
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      placeholder: "Sélectionner la mandature",
                      valueProp: "value",
                      label: "label",
                      searchable: true
                    }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "mandatures",
                  class: "text-danger fs-sm-14"
                })
              ])
            ]),
            (_ctx.lignes.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lignes, (ligne, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-md-6"
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(ligne.nomPoste), 1),
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_Multiselect, {
                              options: _ctx.filteredMembreOptions(index),
                              modelValue: ligne.membreId,
                              "onUpdate:modelValue": ($event: any) => ((ligne.membreId) = $event),
                              placeholder: "Choisir un membre",
                              valueProp: "value",
                              label: "label",
                              searchable: true,
                              mode: "single",
                              "create-option": true,
                              onCreate: ($event: any) => (_ctx.openCreateModal(index, $event)),
                              class: "mb-2"
                            }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onCreate"]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-outline-success w-100",
                              onClick: ($event: any) => (_ctx.openCreateModal(index))
                            }, " + Ajouter un nouveau membre ", 8, _hoisted_14)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_router_link, {
                to: "/liste-assignation",
                class: "btn btn-danger"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Annuler")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tempMembre.nom) = $event)),
                class: "form-control",
                placeholder: "Ex: Diallo"
              }, null, 512), [
                [_vModelText, _ctx.tempMembre.nom]
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tempMembre.prenom) = $event)),
                class: "form-control",
                placeholder: "Ex: Mamadou"
              }, null, 512), [
                [_vModelText, _ctx.tempMembre.prenom]
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("input", {
                type: "file",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                accept: "image/*",
                class: "form-control"
              }, null, 32)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.confirmCreateMembre && _ctx.confirmCreateMembre(...args)))
            }, "Créer et assigner")
          ])
        ])
      ])
    ])
  ], 64))
}